import { Link } from "react-router-dom";
import { useRef, useState } from "react";
import mainlogo from "../mainlogo.png";

function EditNavbar({
  onDelete,
  onInsert,
  onPreview,
  onAddText,
  onInsertImage,
  fontFamily,
  setFontFamily,
  fontSize,
  setFontSize,
  fontColor,
  setFontColor,
  isBold,
  setIsBold,
  isTransparent,
  setIsTransparent,
  onSave,
}) {
  const [deleteInput, setDeleteInput] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const insertPdfInputRef = useRef(null);
  const insertImageInputRef = useRef(null);

  const fontOptions = [
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Courier New",
    "Georgia",
    "Verdana",
    "Impact",
    "Calibri",
    "Cambria",
  ];

  const handleDeleteSubmit = () => {
    if (!deleteInput.trim()) {
      alert("Enter page numbers first");
      return;
    }

    onDelete(deleteInput);
    setDeleteInput("");
    setShowDeleteModal(false);
  };

  const handleInsertPdfChange = (event) => {
    const selectedFile = event.target.files?.[0];

    if (selectedFile) {
      onInsert(null, selectedFile);
    }

    event.target.value = "";
  };

  const handleInsertImageChange = (event) => {
    const selectedFile = event.target.files?.[0];

    if (selectedFile && onInsertImage) {
      onInsertImage(null, selectedFile);
    }

    event.target.value = "";
  };

  const buttonBase = {
    border: "1px solid #e7ebf3",
    borderRadius: "10px",
    padding: "7px 10px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "12px",
    background: "#ffffff",
    color: "#1f2937",
    boxShadow: "0 2px 8px rgba(15,23,42,0.05)",
    whiteSpace: "nowrap",
    transition: "0.2s ease",
    minHeight: "36px",
  };

  const iconButton = {
    ...buttonBase,
    padding: "9px 13px",
  };

  const dangerButton = {
    ...buttonBase,
    background: "linear-gradient(135deg, #ff4b4b, #ef233c)",
    color: "#ffffff",
    border: "none",
  };

  const primaryButton = {
    ...buttonBase,
    background: "linear-gradient(135deg, #2f80ed, #7b4dff)",
    color: "#ffffff",
    border: "none",
  };

  const controlBase = {
    height: "36px",
    border: "1px solid #dbe2ef",
    borderRadius: "10px",
    padding: "0 10px",
    background: "#ffffff",
    color: "#111827",
    outline: "none",
    fontSize: "12px",
    fontWeight: 600,
  };

  return (
    <>
      <header
        className="edit-navbar"
        style={{
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #edf0f5",
          boxShadow: "0 2px 14px rgba(15,23,42,0.05)",
          position: "sticky",
          top: 0,
          zIndex: 5000,
        }}
      >
        <div
          style={{
            minHeight: "64px",
            padding: "12px clamp(14px, 3vw, 34px)",
            display: "flex",
            alignItems: "center",
            gap: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flex: "0 0 auto",
            }}
          >
            <img
              src={mainlogo}
              alt="SmartPDF Logo"
              style={{
                width: "38px",
                height: "38px",
                objectFit: "contain",
              }}
            />

            <div style={{ lineHeight: 1.15 }}>
              <h2
                style={{
                  margin: 0,
                  fontSize: "clamp(18px, 2vw, 27px)",
                  fontWeight: 800,
                  color: "#18233f",
                  letterSpacing: "-0.8px",
                }}
              >
                Smart<span style={{ color: "#7b4dff" }}>PDF</span>
              </h2>
              <p
                style={{
                  margin: "4px 0 0",
                  color: "#64748b",
                  fontSize: "13px",
                  display: "none",
                }}
              >
                Editor
              </p>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              overflowX: "hidden",
              overflowY: "visible",
              whiteSpace: "normal",
              flex: "1 1 auto",
              minWidth: 0,
            }}
          >
            <button onClick={() => setShowDeleteModal(true)} style={dangerButton}>
              🗑️ Delete
            </button>

            <button
              onClick={() => insertPdfInputRef.current?.click()}
              style={buttonBase}
            >
              📄 Insert PDF
            </button>

            <button
              onClick={() => insertImageInputRef.current?.click()}
              style={buttonBase}
            >
              🖼️ Insert Image
            </button>

            <button onClick={onAddText} style={buttonBase}>
              ✏️ Add Text
            </button>

            <button onClick={onPreview} style={buttonBase}>
              👁️ Preview
            </button>

            <button onClick={onSave} style={primaryButton}>
              💾 Save
            </button>

            <input
              ref={insertPdfInputRef}
              type="file"
              accept="application/pdf"
              onChange={handleInsertPdfChange}
              style={{ display: "none" }}
            />

            <input
              ref={insertImageInputRef}
              type="file"
              accept="image/*"
              onChange={handleInsertImageChange}
              style={{ display: "none" }}
            />

            <span
              style={{
                height: "32px",
                width: "1px",
                background: "#e2e8f0",
                flex: "0 0 auto",
              }}
            />

            <select
              value={fontFamily}
              onChange={(event) => setFontFamily(event.target.value)}
              style={{ ...controlBase, width: "160px" }}
            >
              {fontOptions.map((font) => (
                <option key={font} value={font}>
                  {font}
                </option>
              ))}
            </select>

            <input
              type="number"
              value={fontSize}
              onChange={(event) => setFontSize(Number(event.target.value))}
              min="8"
              max="96"
              style={{ ...controlBase, width: "72px", textAlign: "center" }}
            />

            <input
              type="color"
              value={fontColor}
              onChange={(event) => setFontColor(event.target.value)}
              title="Font color"
              style={{
                width: "42px",
                height: "39px",
                border: "1px solid #dbe2ef",
                borderRadius: "999px",
                cursor: "pointer",
                background: "#ffffff",
                padding: "5px",
                flex: "0 0 auto",
              }}
            />

            <button
              onClick={() => setIsBold(!isBold)}
              style={{
                ...iconButton,
                background: isBold ? "#18233f" : "#ffffff",
                color: isBold ? "#ffffff" : "#18233f",
                fontWeight: 900,
              }}
              title="Bold"
            >
              B
            </button>

            <button
              onClick={() => setIsTransparent(!isTransparent)}
              style={{
                ...buttonBase,
                background: isTransparent ? "#10b981" : "#ffffff",
                color: isTransparent ? "#ffffff" : "#18233f",
              }}
              title="Transparent background"
            >
              Transparent
            </button>
          </div>

          <Link to="/" style={{ flex: "0 0 auto", textDecoration: "none" }}>
            <button style={buttonBase}>Home</button>
          </Link>
        </div>
      </header>

      {showDeleteModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(15, 23, 42, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              padding: "24px",
              borderRadius: "18px",
              width: "100%",
              maxWidth: "420px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#111827" }}>Delete Pages</h3>

            <p style={{ color: "#6b7280", fontSize: "13px" }}>
              Supported formats: <b>1</b>, <b>1,5,9</b>, <b>1-5</b>,{" "}
              <b>1,5,9,15-20</b>
            </p>

            <input
              type="text"
              value={deleteInput}
              onChange={(event) => setDeleteInput(event.target.value)}
              placeholder="Example: 1,5,9,15-20"
              style={{
                width: "100%",
                padding: "12px",
                margin: "12px 0",
                borderRadius: "12px",
                border: "1px solid #d1d5db",
                outline: "none",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            />

            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
                marginTop: "14px",
              }}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                style={buttonBase}
              >
                Cancel
              </button>

              <button onClick={handleDeleteSubmit} style={dangerButton}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EditNavbar;